import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@vd/ui';
import styles from './WalkthroughRecordingTab.module.css';

/**
 * Where a person's own recording setting lives (TOADO-383).
 *
 * The project can defer to "whatever the person recording has chosen", which
 * raises the obvious question of where anybody chooses that. It is in the
 * extension, which is a surface the web app cannot link to, so this shows it.
 */
export function PersonalRecordingSettingModal({ open, onClose }: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Modal open={open} onClose={onClose} width={660}>
      <ModalHeader>Where each person chooses theirs</ModalHeader>
      <ModalBody>
        <div className={styles.modalSteps}>
          <div className={styles.step}>
            <h4 className={styles.stepTitle}>1. Open the Toado extension and click Settings</h4>
            <p className={styles.stepBody}>
              Click the Toado icon in the browser toolbar, then Settings at the bottom right
              of the popup.
            </p>
            <span className={styles.shotFrame}>
              <img
                className={styles.shot}
                src="/help/walkthrough/popup-settings-button.png"
                alt="The Toado extension popup, with the Settings button at the bottom right."
                width={380}
                height={291}
              />
            </span>
          </div>

          <div className={styles.step}>
            <h4 className={styles.stepTitle}>2. Choose under Walkthrough recording</h4>
            <p className={styles.stepBody}>
              Near the bottom of the extension settings there are two choices: screen and
              narration, or narration only. That choice applies to every project that has not
              made one of its own, and it is per person and per browser, so it does not change
              anything for your teammates.
            </p>
            {/* Cropped to the section this step is about. The whole capture
                is nearly a thousand pixels tall and starts with the connection
                fields, so at any size that fitted in the dialog the part being
                described was off the bottom. */}
            <span className={styles.shotFrame}>
              <img
                className={styles.shot}
                src="/help/walkthrough/extension-settings-recording.png"
                alt="The Walkthrough recording section of the extension settings, showing the screen-and-narration and narration-only choices."
                width={594}
                height={278}
              />
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose}>Got it</Button>
      </ModalFooter>
    </Modal>
  );
}
